import { SxProps, Theme } from '@mui/material';

// Grid styles for 2x2 artwork layout
export const container: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export const grid: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '1fr 1fr',
  gap: '2px',
  width: '100%',
  height: '100%',
};

export const gridItem: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  borderRadius: '4px',
};
